import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-cement-catalog',
    template: `
    <app-tool-loader [isLoading]="false" positionUnset="true">
      <app-formations-cement-catalog [catalogType]="'cement'" [componentId]="componentId"></app-formations-cement-catalog>
    </app-tool-loader>
  `,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CementCatalogComponent {
  @Input() public componentId!: string;
}
